import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';
import { useState } from 'react';
import { useFloating, useHover, useFocus, useDismiss, useRole, useInteractions, FloatingPortal } from '../../node_modules/@floating-ui/react/dist/floating-ui.react.js';
import { autoUpdate } from '../../node_modules/@floating-ui/dom/dist/floating-ui.dom.js';
import { offset, flip, shift } from '../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.js';

/**
Il componente visualizza un testo in pop over al mouse over.

_ATTENZIONE_ l'attuale implementazione ha dei problemi con certi tipi di overflow.
Può accadere infatti che il testo in pop over venga "coperto" da contenuti al di fuori del div che lo contiene.
Questo vale per tutti i componenti che lo utilizano (Ellipsis, InfoToolip).
 */
function TooltipNew({ children = undefined, content, enableFunction = undefined, className = undefined, }) {
    const enable = !enableFunction || enableFunction();
    const classes = cns('infoTooltip', 'floating-ui', {
        'infoTooltip--enable': enable,
    }, className);
    const [isOpen, setIsOpen] = useState(false);
    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        // Make sure the tooltip stays on the screen
        whileElementsMounted: autoUpdate,
        middleware: [
            offset(5),
            flip({
                fallbackAxisSideDirection: 'start',
            }),
            shift(),
        ],
    });
    // Event listeners to change the open state
    const hover = useHover(context, { move: false });
    const focus = useFocus(context);
    const dismiss = useDismiss(context);
    // Role props for screen readers
    const role = useRole(context, { role: 'tooltip' });
    // Merge all the interactions into prop getters
    const { getReferenceProps, getFloatingProps } = useInteractions([
        hover,
        focus,
        dismiss,
        role,
    ]);
    return (jsxs(Fragment, { children: [jsx("div", Object.assign({ className: classes, "data-clickable": "false", ref: refs.setReference }, getReferenceProps(), { children: children })), jsx(FloatingPortal, { children: enable && isOpen && (jsx("div", Object.assign({ className: "infoTooltip__content", "data-clickable": "false", ref: refs.setFloating, style: floatingStyles }, getFloatingProps(), { children: content }))) })] }));
}

export { TooltipNew as default };
